import React from "react";

const CarSupport = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-sans py-12 lg:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <div className="inline-block bg-blue-100 text-blue-700 p-4 rounded-full mb-6 text-3xl">
            🛠️
          </div>
          <h1 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight mb-4">
            24/7 Car Rental Support
          </h1>
          <p className="text-slate-500 text-lg font-medium">
            Need to change your booking or having trouble on the road? We're
            here to help.
          </p>
        </div>

        <div className="bg-white rounded-[2rem] border border-slate-200 shadow-xl overflow-hidden">
          <div className="p-8 sm:p-12">
            <h2 className="text-xl font-bold text-slate-900 mb-6 border-b border-slate-100 pb-4">
              Submit a Support Request
            </h2>

            <form className="space-y-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                    Reservation Number
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. CR-98372"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 outline-none focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                    Main Driver Last Name
                  </label>
                  <input
                    type="text"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 outline-none focus:border-blue-500"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-4">
                  What do you need help with?
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    "Change Pick-up Date/Time",
                    "Change Drop-off Location",
                    "Cancel Reservation",
                    "Add Insurance / Protection",
                    "Billing Inquiry",
                    "On-Road Breakdown",
                  ].map((item, idx) => (
                    <label
                      key={idx}
                      className="flex items-center gap-3 p-4 border border-slate-200 rounded-xl cursor-pointer hover:bg-slate-50 transition-colors"
                    >
                      <input
                        type="radio"
                        name="support_type"
                        className="w-5 h-5 rounded-full border-slate-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className="font-semibold text-slate-700 text-sm">
                        {item}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                  Additional Details
                </label>
                <textarea
                  placeholder="Please describe your issue or the changes you need..."
                  rows="4"
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 outline-none focus:border-blue-500 resize-none"
                ></textarea>
              </div>

              <div className="bg-blue-50 p-4 rounded-xl flex items-start gap-3">
                <span className="text-blue-600 text-xl">ℹ️</span>
                <p className="text-xs text-blue-800 font-medium">
                  For immediate on-road emergencies or breakdowns, please
                  contact the rental agency's direct roadside assistance number
                  provided on your rental agreement.
                </p>
              </div>

              <button
                type="button"
                className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-bold py-3.5 px-10 rounded-xl transition-all active:scale-95 shadow-md shadow-blue-600/20"
              >
                Submit Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarSupport;
